export default __webpack_public_path__ + "static/FAQ_ELGAP_EN-59c26204d9dcdb2c59cd84dac9d0ca23.pdf";